const o = (e) => ({
  backdrop: {
    zIndex: e.zIndex.drawer + 1,
    color: e.palette.common.white
  }
}), t = o;
export {
  t as default
};
